import Countdown from './Countdown'

// function App() {
//   return (
//     <Countdown/>    
//   );
// }

// eslint-disable-next-line import/no-anonymous-default-export
export default () => <Countdown/>;
